import { render } from "./monthly-overview.vue?vue&type=template&id=37064cde"
import script from "./monthly-overview.vue?vue&type=script&lang=js"
export * from "./monthly-overview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__